import React, { useMemo } from "react";

import { Center, ChakraProvider, extendTheme } from "@chakra-ui/react";
import { chakraTheme } from "@ovou-inc/ovou-ui/theme";
import { QueryCache, ReactQueryCacheProvider } from "react-query";
import { Switch, Redirect } from "react-router-dom";

import { RouteWrapper } from "./components";
import { MANAGE_USERS_ROUTE } from "./constants";
import { useIdentify, useValidateToken } from "./hooks";
import { routes } from "./routes";
import { getToken } from "./utils";
import "cropperjs/dist/cropper.css";
import "@fontsource/inter/200.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/800.css";
import Loader from "components/Spinner/Loader";
import { useAddPaymentCallback } from "./hooks/useAddPaymentCallback";
const cache = new QueryCache();
const theme = extendTheme(chakraTheme);

const App = () => {
  useIdentify();
  const { isValidating } = useValidateToken();
  const { isPaymentCallbackActive } = useAddPaymentCallback();

  const baseRoute = routes.find(route => route.path === MANAGE_USERS_ROUTE);

  const { accessToken } = useMemo(() => getToken(), []);

  return (
    <ReactQueryCacheProvider queryCache={cache}>
      <div className="min-h-screen h-screen bg-white">
        <ChakraProvider theme={theme}>
          {isValidating || isPaymentCallbackActive ? (
            <Center height="full">
              <Loader />
            </Center>
          ) : (
            <Switch>
              {routes.map((route, index) => (
                <RouteWrapper exact key={index} {...route} />
              ))}
              <Redirect
                from="/"
                to={accessToken ? baseRoute.path : "/auth/login"}
              />
            </Switch>
          )}
        </ChakraProvider>
      </div>
    </ReactQueryCacheProvider>
  );
};

export default App;
